module.exports = __webpack_public_path__ + "img/bookings-light.357a6bfb.svg";